<template>
	<nav :class="['sticky-sidebar__container col-12', classes]">
		<div class="sticky-sidebar" :class="{ expanded: isExpanded }">
			<button
				class="sticky-sidebar__heading overline pl-100 pr-100 pt-50 pb-50 br-0 bt-0 bl-0 bb-0"
				:class="{
					'pt-100 pb-100 in-page-nav-button-inverted-colors': navStyle === 'cards'
				}"
				:disabled="isDisabled"
				@click="toggleDrawer"
			>
				<slot> Jump To </slot>
				<span class="display-none-lg ml-25">
					<BaseSvgIcon name="chevron" height="20" width="20" class="chevron-icon" />
				</span>
			</button>
			<TransitionCollapse>
				<ul v-if="isExpanded" class="sticky-sidebar__list pt-100 pr-100 pb-100 br bl bb-0 bb-lg">
					<li
						v-for="anchor in navInfo.anchors"
						:key="anchor.slug"
						v-on="closeNavOnClick ? { click: toggleDrawer } : {}"
					>
						<BaseLink
							:link="{
								router: navInfo.routeName,
								params: navInfo.routeParams ? navInfo.routeParams : {},
								hash: '#' + anchor.slug,
								text: anchor.heading
							}"
							:classes="`zeta display-inline-block pl-100${closeNavOnClickLinkStyle}`"
						/>
					</li>
				</ul>
			</TransitionCollapse>
		</div>
	</nav>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { InPageNavInfo, InPageNavStyle } from 'types/layout';
import { ScreenSizeType } from 'types/client';
import TransitionCollapse from '@components/layout/transition-collapse.vue';
import { useAppStore } from '@stores/app';
interface Props {
	navInfo: InPageNavInfo;
	classes?: string;
	navStyle?: InPageNavStyle;
	closeNavOnClick?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
	navStyle: 'article',
	classes: undefined,
	closeNavOnClick: false
});

const appStore = useAppStore();

const isDisabled = ref(false);
const isExpanded = ref(true);

const screenSize = computed((): ScreenSizeType => {
	return appStore.screenSize;
});

const closeNavOnClickLinkStyle = computed((): string => {
	return props.closeNavOnClick ? ' col-12 remove-border-on-click' : '';
});

function toggleDrawer(): void {
	isExpanded.value = !isExpanded.value;
}

watch(
	() => screenSize.value,
	(newScreenSize: ScreenSizeType) => {
		updateScreenSizeDependentVariables(newScreenSize === 'DESKTOP');
	}
);

function updateScreenSizeDependentVariables(desktopSize: boolean): void {
	if (desktopSize) {
		isExpanded.value = true;
		isDisabled.value = true;
	} else {
		isExpanded.value = false;
		isDisabled.value = false;
	}
}

function setup(): void {
	updateScreenSizeDependentVariables(screenSize.value === 'DESKTOP');
}
setup();
</script>
<style lang="scss">
@use '../../styles/constants/colors.scss' as *;

.in-page-nav-button-inverted-colors {
	background-color: white !important;
	color: token('content-secondary') !important;
}

.remove-border-on-click {
	&:hover,
	&:focus {
		border: 0 transparent !important;
	}
}
</style>
